window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if(src === null) {
      return;
    }

    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

   /**
     * Get params from the URL
     *
     */
    _getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

        /**
     * Update history state for product deeplinking
     *
     * @param  {querystring} queryString - What you want appended after the URL on the PDP
     * @return {k}         [description]
     */
    _historyStateUrlUpdate: function(queryString) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + queryString;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update history state for product deeplinking, take UTM from bouncex into account, don't just remove it if utm_source=bouncex
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */

    _updateHistoryState: function(variant) {

      if (!history.replaceState || !variant) {
        return;
      }
      var url = window.location.href;

      if(url.indexOf('?variant=') == -1){
        var querystring = window.location.search.substring(1);
        var utm = this._getParameterByName('utm_source');

        if(utm == 'bouncex'){
          var updateQueryString = variant.id + '&' + querystring;
          this._historyStateUrlUpdate(updateQueryString);
        }
        else {
          this._historyStateUrlUpdate(variant.id);
        }
      }
      else {
        this._historyStateUrlUpdate(variant.id);
      }
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * AJAX Cart scripts
 * ------------------------------------------------------------------------------
 *
 * Usage: slate.AjaxCart.init(options);
 *
 * Requires:
 *  - jQuery
 *  - Handlebars
 *  - Slate
 *  - theme.strings (see layout/theme.liquid)
 */

(function($, Handlebars, slate, theme){

  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

  jQuery.fn.extend({
    resolveGC: function(data) {
      if(typeof bonus_vars == 'undefined') return false;
      var gc = 0;
      var variant = 0;
      
      $.each(bonus_vars, function( index, value ) {
        if(data.original_total_price >= value[0] && gc < value[1]){
          gc = value[1];
          variant = index;
        }
      });

      var applied_gc = new Array();
     
      //check current GC
      var updateCart = {};
      if(data.items.length > 0){
        $.each(data.items, function( index, value ) {
          if(typeof bonus_vars[value.variant_id] != 'undefined'){
            
            if(value.variant_id != variant){
            
              updateCart[value.variant_id] = 0 ;
            }else{
              //check if there are more than 1
              if(value.quantity > 1){
                updateCart[variant] = 1;
              }
            }
          }
        });
      }

      if(gc){
        updateCart[variant] = 1;
      }
     
      if(updateCart){
        return jQuery.post('/cart/update.js', {updates: updateCart},function(){}, "json");
      }
    }
  });

  /*============================================================================
    API Functions
  ==============================================================================*/
 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */

 ShopifyAPI.removeGift = function(_this, cutRemoveTotalNumber) {
    var gwpId = theme.strings.gwpId;
    var gwpThreshold = theme.strings.gwpThreshold;
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(data) {
            var cutFinalTotalNumber = ShopifyAPI.removeZeros(data.original_total_price);
            // If cart total is more than the threshold set in the admin
            var items = data['items'];

            for (var i = 0; i < items.length; i++) {
                // If cart contains product with id from the setting
                if (items[i].id === gwpId) {
                    var cutItemTotalNumber = ShopifyAPI.removeZeros(items[i].price);
                }
            }

            var cartItemsTotal = cutFinalTotalNumber - cutItemTotalNumber - cutRemoveTotalNumber;
            if (cartItemsTotal < gwpThreshold) {
                ShopifyAPI.changeItemQuantity(gwpId, 0).then(_this._getCartTemplateData.bind(_this)).then(_this.buildCart.bind(_this));
            }
        }
    });
}

ShopifyAPI.removeZeros = function(number) {
  var cutFinalTotalZeros = number.toString().slice(0, -2);
  return Number(cutFinalTotalZeros);
}

ShopifyAPI.removeZerosAndDollarfunction = function(number) {
  var cutRemoveZeros = number;
  var cutRemoveTotalZeros = cutRemoveZeros.toString().slice(1, -3);
  return Number(cutRemoveTotalZeros);
}

ShopifyAPI.updateGwpPrice = function(total) {
  var gwpId = theme.strings.gwpId;
  var foundItem = $(".AjaxCart-list").find("[data-id='" + gwpId + "']");
  var foundPrice = foundItem.find(".AjaxCart-itemPrice");
  if (total) {
      $("#ajax-cart-total").text('$' + total + '.00');
  }
  foundPrice.text('$0.00');
}

 ShopifyAPI.gwp = function(promise) {
  // If gift with purchase is turned on
  if (theme.strings.gwpSet) {
      var gwpId = theme.strings.gwpId;
      var gwpThreshold = theme.strings.gwpThreshold;

      $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function(data) {
              var items = data['items'];
              var containFreeProduct = false;
              for (var i = 0; i < items.length; i++) {
                  // If cart contains product with id from the setting
                  if (items[i].id === gwpId) {
                      var containFreeProduct = true;
                  }
              }
              // If free product is not in the cart
              if (!containFreeProduct) {
                  $.ajax({
                      type: 'GET',
                      url: '/cart.js',
                      cache: false,
                      dataType: 'json',
                      success: function(data) {
                          var cutFinalTotalNumber = ShopifyAPI.removeZeros(data.original_total_price);
                           // If cart total is more than the threshold set in the admin
                          if (cutFinalTotalNumber >= gwpThreshold) {
                              $.ajax({
                                  type: 'post',
                                  dataType: 'json',
                                  url: '/cart/add.js',
                                  data: 'id=' + gwpId + '&quantity=1',
                                  success: function() {
                                      ShopifyAPI.getCart().then(function(data) {
                                        var resolver =  promise.resolve(data);
                                        resolver.then(function(v) {
                                            setTimeout(function() {
                                              ShopifyAPI.updateGwpPrice(cutFinalTotalNumber);
                                            }, 1000);

                                          }, function(e) {
                                            // not called
                                        });
                                      });
                                  },
                                  error: function () {
                                    //no GWP availible
                                    console.log('Problem with gift product, possibly out of stock.');
                                    promise.resolve(data);
                                  }
                              });
                          } else {
                              promise.resolve(data);
                          }
                      },
                      error: function () {
                        //problem with get cart.js
                        console.log('Problem with getting cart json.');
                        promise.resolve(data);
                      }
                  });
              } 
               // If free product is in the cart
              else {
                  promise.resolve(data);
              }
          }
      });
  }
};

 /**
  * AJAX submit an 'add to cart' form
  *
  * @param {jQuery} $form - jQuery instance of the form
  * @return {Promise} - Resolve returns JSON cart | Reject returns an error message
  */
  ShopifyAPI.addItemFromForm = function($form) {
    var promise = $.Deferred();

    $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/add.js',
      data: $form.serialize(),
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
            // If gift with purchase is turned on
          if(!theme.strings.gwpSet) {
            //CUSTORA add first product in cart
              if(data.items.length > 0){
                dataLayer.push({
                  'productId': data.items[0].id,
                  'productSKU': data.items[0].sku,
                  'price': data.items[0].price,
                  'quantity': data.items[0].quantity,
                  'productName': data.items[0].title,
                  'event': 'addToCart'
                });
              }
            promise.resolve(data);
          }
          else {
            ShopifyAPI.gwp(promise);
          }
        });
      },
      error: function () {
        promise.reject({
          message: 'Quantity Unavailable'
        });
      }
    });

    return promise;
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getCart = function() {
    return $.getJSON('/cart.js');
  };

 /**
  * Retrieve a JSON respresentation of the users cart
  *
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.getProduct = function(handle) {
    return $.getJSON('/products/' + handle + '.js');
  };

 /**
  * Change the quantity of an item in the users cart
  *
  * @param {int} variantId - Variant to be adjust
  * @param {int} qty - New quantity of the variant
  * @return {Promise} - JSON cart
  */
  ShopifyAPI.changeItemQuantity = function(variantId, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + variantId,
      dataType: 'json'
    });
  };

  /*============================================================================
    Ajax Shopify Add To Cart
  ==============================================================================*/
  slate.AjaxCart = (function() {

    var $window = $(window);
    var $body = $('body');

    var selectors = {
      container: '[data-ajax-cart-container]',
      template: 'script[data-ajax-cart-template]',
      trigger: '[data-ajax-cart-trigger]',
      close: '[data-ajax-cart-close]',
      addForm: 'form[action^="/cart/add"]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      item: '[data-ajax-item][data-id][data-qty]',
      itemRemove: '[data-ajax-cart-item-remove]',
      cartScrollList: '[data-ajax-cart-scroll-list]',
      cartCount: '[data-cart-count]'
    };

    var breakpoints = {
      XS: 576, 
      SM: 768,
      MD: 992,
      LG: 1200,
      XL: 1400
    };

   /**
    * AjaxCart constructor
    *
    * Adds an `init` method with access to private variables inside the contructor
    */
    function AjaxCart() {
      this.name = 'ajaxCart'
      this.namespace = '.' + this.name;
      this.events = {
        RENDER: 'render'   + this.namespace,
        DESTROY: 'destroy'   + this.namespace
      };

      // Cache products here as we fetch them via ajax so we can make less successive requests
      this.productStore = {};

      var initialized = false;
      var settings = {
        disableAjaxCart: false,
        disableForMobile: true
      };

     /**
      * Call this from the main theme.js file to initialize the ajaxCart
      *
      * @param {object} options - see `settings` variable above
      */
      this.init = function(options) {
        if(initialized) return;

        this.settings = $.extend(settings, options);

        if(!$(selectors.template).length){
          console.warn('['+this.name+'] - Handlebars template required to initialize AjaxCart');
          return;
        }

        // Compile this once during initialization
        this.template = Handlebars.compile($(selectors.template).html());

        // Add the AJAX part
        if(!this.settings.disableAjaxCart && $(selectors.addForm).length) {
          this._formOverride();
        }

        // Add event handlers here
        $body.on('click', selectors.trigger, this.onTriggerClick.bind(this));
        $body.on('click', selectors.close, this.onCloseClick.bind(this));
        $body.on('click', selectors.itemRemove, this.onItemRemoveClick.bind(this));
        // Have to do it this way because scroll events don't bubble
        $window.on(this.events.RENDER, this.onCartRender.bind(this));
        $window.on(this.events.DESTROY, this.onCartDestroy.bind(this));
        $window.on('resize' + this.namespace, $.throttle(200, this.onResize.bind(this)));

        // Get the cart data when we initialize the instance
        ShopifyAPI.getCart().then(this._getCartTemplateData.bind(this)).then(this.buildCart.bind(this));

        initialized = true;

        return initialized;
      };

      return this;
    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

      _isMobile: function() {
        return $window.width() < breakpoints.SM;
      },

     /**
      * Call this function to AJAX-ify any add to cart forms on the page
      */
      _formOverride: function() {
        var self = this;

        $body.on('submit', selectors.addForm, function(e) {

          if(self.settings.disableForMobile && self._isMobile()) {
            return true;
          }

          e.preventDefault();

          var $submitButton = $(e.target).find(selectors.addToCart);
          var $submitButtonText = $submitButton.find(selectors.addToCartText);

          // Update the submit button text and disable the button so the user knows the form is being submitted
          $submitButton.prop('disabled', true);
          $submitButtonText.html(theme.strings.adding);

          ShopifyAPI.addItemFromForm( $(e.target) )
            .then(function(data){
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              self.onItemAddSuccess.call(self, data);
            })
            .fail(function(data){
              // Reset button state
              $submitButton.prop('disabled', false);
              $submitButtonText.html(theme.strings.addToCart);
              self.onItemAddFail.call(self, data);
            });

        });
      },

     /**
      * Gets data necessary to build the cart HTML.
      * Not only do we need the JSON cart, we need the JSON for all products in the cart too.
      * Check the productStore instance variable first, and then fetch JSON for each product that doesn't exist in the store
      *
      * @param {Object} cart - JSON representation of the cart.
      * @return {$.Deferred} promise
      */
      _getCartTemplateData: function(cart){

        $.fn.resolveGC(cart);

        var _this = this;
        var promise = $.Deferred();
        var requests = [];
        var templateData = {
          cart: cart,
          products: []
        };

        for (var i = cart.items.length - 1; i >= 0; i--) {
          if(!_this.productStore.hasOwnProperty(cart.items[i].product_id)) {
            requests.push(ShopifyAPI.getProduct(cart.items[i].handle));
          }
        };

        $.when.apply($, requests).then(function(resp){

          var products = arguments;

          // If we make one request, we get returned an array of plain objects
          // If we make more than one request, we get returned an array of arrays (of plain objects)
          // We have an array of arrays
          if($.isArray(arguments[0])){
            products = $.map(arguments, function (arg) { return arg[0]; });
          }

          // Update our product store with any products that don't already exist in there
          if(products && products.length) {
            for (var i = products.length - 1; i >= 0; i--) {
              var p = products[i];
              _this.productStore[p.id] = p;
            }            
          }

          templateData.products = _this.productStore;
          promise.resolve(templateData);
        });

        if (theme.strings.gwpSet) {
          setTimeout(function() {
            ShopifyAPI.updateGwpPrice();
          }, 1000);
        }

        return promise;
      },

     /**
      * Callback when adding an item is successful
      *
      * @param {Object} cart - JSON representation of the cart.
      */
      onItemAddSuccess: function(cart){
        this._getCartTemplateData(cart).then(function(data){
          this.buildCart(data);
          this.open();
        }.bind(this));

      },

     /**
      * Callback when adding an item fails
      *
      * @param {Object} data
      * @param {string} data.message - error message
      */
      onItemAddFail: function(data){
        $(selectors.addToCartText).html(data.message);
      },

     /**
      * Builds the HTML for the ajax cart.
      * Modifies the JSON cart for consumption by our handlebars template
      *
      * @param {object} cartTemplateData
      * @param {object} cartTemplateData.cart - JSON representation of the cart.  See https://help.shopify.com/themes/development/getting-started/using-ajax-api#get-cart
      * @param {object} cartTemplateData.products - Plain object of product JSON values, keyed with the product ID.
      * @return ??
      */
      buildCart: function(cartTemplateData) {

        var cart     = cartTemplateData.cart;
        var products = cartTemplateData.products;

       // ShopifyAPI.gwp();

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);

        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
          item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          item.giftcard = item.handle === "gift-card";

          // Adjust the item's variant options to add "name" and "value" properties
          if(products.hasOwnProperty(item.product_id)) {
            var product = products[item.product_id];
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var value = item.variant_options[i];
              item.variant_options[i] = {
                name: product.options[i].name,
                value: value
              }
            }
          }

          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegent way to update the cart but it works...
         */

         $window.trigger(this.events.DESTROY);
         $(selectors.container).empty().append( this.template(cart) );
         $window.trigger(this.events.RENDER);

         this.updateCartCount(cart);
      },

     /**
      * Checks the cart scroll list height and adds / remove classes for overflow
      *
      */
      _cartCheckOverflow: function() {
        var $cartScrollList = $(selectors.cartScrollList);

        if(!$cartScrollList.length) {
          return;
        }

        if($cartScrollList.get(0).scrollHeight > $cartScrollList.height()){
          $cartScrollList.addClass('has-overflow');
        }
        else {
          $cartScrollList.removeClass('has-overflow');
        }
      },

     /**
      * Callback for when the cart HTML is rendered to the page
      * Allows us to add event handlers for events that don't bubble
      */
      onCartRender: function(e) {

        var $cartScrollList = $(selectors.cartScrollList);

        $cartScrollList.on('scroll', $.throttle(250, this.onCartListScroll.bind(this, $cartScrollList)));
        this._cartCheckOverflow();
        this.onCartListScroll($cartScrollList);
      },

     /**
      * Callback for when the cart HTML is removed from the page
      * Allows us to do cleanup on any event handlers applied post-render
      */
      onCartDestroy: function(e) {
        $(selectors.cartScrollList).off('scroll');
      },

     /**
      * Called when the list is scrolled, checks scroll progress and adds / removes necessary classes for visual effects
      * Allow us to pass in the $list variable as an argumnent to avoid doing DOM lookups everytime we call this function
      */
      onCartListScroll: function($list) {

        if(!$list){
          $list = $(selectors.cartScrollList);
        }

        if(!$list.length) {
          return
        }

        var scrollThreshold = 8; // px distance to determine 'at-top' or 'at-bottom'
        var scrollHeight    = $list.get(0).scrollHeight;
        var outerHeight     = $list.outerHeight();
        var scrollTop       = $list.scrollTop();
        var scrollBottom    = Math.round(scrollHeight - (outerHeight + scrollTop));

        window.requestAnimationFrame(function(){
          if(scrollTop < scrollThreshold) {
            $list.addClass('is-at-top');
          }
          else {
            $list.removeClass('is-at-top');
          }

          if(scrollBottom < scrollThreshold) {
            $list.addClass('is-at-bottom');
          }
          else {
            $list.removeClass('is-at-bottom');
          }
        });

      },

     /**
      * Cart visuals are dependent on the size of the cart element
      * Make sure everything looks good post-resize event
      */
      onResize: function(){
        this._cartCheckOverflow();
        this.onCartListScroll();
      },

     /**
      * Remove the item from the cart.  Extract this into a separate method if there becomes more ways to delete an item
      *
      * @param {event} e - Click event
      */
      onItemRemoveClick: function(e) {
        e.preventDefault();

          var $itemRow = $(e.target).parents(selectors.item)
          var id = $itemRow.attr('data-id');

          $itemRow.addClass('is-being-removed');
          ShopifyAPI.changeItemQuantity(id, 0).then(this._getCartTemplateData.bind(this)).then(this.buildCart.bind(this));
          
          if (theme.strings.gwpSet) {
            var foundIdPrice = $itemRow.find(".AjaxCart-itemPrice");
            var cutRemoveTotalNumber = ShopifyAPI.removeZerosAndDollarfunction(foundIdPrice[0].innerText);
            var _this = this;
            // If removing item from the cart, remove gift as well
            ShopifyAPI.removeGift(_this, cutRemoveTotalNumber);
          }
      },

     /**
      * Click the 'ajaxCart - trigger' selector
      *
      * @param {event} e - Click event
      */
      onTriggerClick: function(e) {
        if(this.settings.disableForMobile && this._isMobile()){
          return;
        }

        e.preventDefault();
        this.toggleVisibility();
      },

     /**
      * Click the 'ajaxCart - close' selector
      *
      * @param {event} e - Click event
      */
      onCloseClick: function(e) {
        e.preventDefault();

        // Do any cleanup here before closing the cart
        this.close();
      },

      toggleVisibility: function() {
        return this.isOpen() ? this.close() : this.open();
      },

      isOpen: function() {
        return $(selectors.container).hasClass('is-open');
      },

      isClosed: function() {
        return !this.isOpen();
      },

      updateCartCount: function(cart) {
        var $count = $(selectors.cartCount);
        $count.html(cart.item_count);
        if(cart.item_count) {
          $count.addClass('has-items');
        }
        else {
          $count.removeClass('has-items');
        }
      },

     /**
      * Code for opening the cart
      */
      open: function() {
        $(selectors.container).addClass('is-open');
      },

     /**
      * Code for closing the cart
      */
      close: function() {
        $(selectors.container).removeClass('is-open');
      }
    });

    return new AjaxCart();
  })();

})(jQuery, Handlebars, slate, theme);

/**
 * Product Thumbnails
 * -----------------------------------------------------------------------------
 * Script for handling product thumbnails - grid items that show up on collection-type pages.  Extracted this outside of collection section js since these product thumbnails show up on CLP and product pages
 *
 * Usage - call `slate.ProductThumbnails.init()` on any page that has these elements
 */

slate.ProductThumbnails = (function() {

  var initialized = false;
  var selectors = {
    productThumbnail: '[data-product-thumbnail]',
    productThumbnailImg: '[data-product-thumbnail-img]',
    swatch: '[data-swatch]',
    swatchOverflowToggle: '[data-swatch-overflow-toggle]'
  };

  var onSwatchClick = function(e) {
    var $swatch = $(e.currentTarget);
    var activeClass = 'is-active';

    if($swatch.hasClass( activeClass )){
      return;
    }

    var $product = $swatch.parents(selectors.productThumbnail);
    var url      = $swatch.data('variant-url');
    var img      = $swatch.data('variant-img');

    $product.find('a').attr('href', url);
    $product.find( selectors.productThumbnailImg ).attr('src', img);
    $product.find( selectors.swatch ).removeClass( activeClass );
    $swatch.addClass( activeClass );
  };

  // Removes the overflow class from the parent swatch list
  // hides the toggle button
  var onSwatchOverflowToggleClick = function(e) {
    e.preventDefault();
    var $toggle = $(e.currentTarget);
    var overflowClass = 'Swatches__list--has-overflow';

    $toggle.parents().removeClass(overflowClass);
    $toggle.addClass('hide');
  }

  var init = function() {
    
    if(initialized) return;

    $(selectors.productThumbnail).on('click', selectors.swatch, onSwatchClick);
    $(selectors.productThumbnail).on('click', selectors.swatchOverflowToggle, onSwatchOverflowToggleClick);

    initialized = true;
  };

  return {
    init: init
  };

})();
/**
 * Back to top button
 * -----------------------------------------------------------------------------
 * Handles hiding / showing of the back to top button as well as click events, animating scroll.
 */

slate.BackToTop = (function() {
  var selectors = {
    backToTop: '[data-back-to-top]'
  }

  var $window = $(window);
  var $body = $(document.body);
  var $btn = $(selectors.backToTop);
  var initialized = false;
  var activeClass = 'is-active';
  var name = 'backToTop';
  var namespace = '.' + name;

  function onScroll() {

    var scrollTop = $window.scrollTop();
    var windowSize = window.innerHeight;

    if(scrollTop > windowSize) {
      $btn.addClass( activeClass );
    }
    else {
      $btn.removeClass( activeClass );
    }
  }

  function onBtnClick(e) {
    e.preventDefault();

    removeScrollHandler();
    $btn.removeClass( activeClass );

    $('html, body').animate({ scrollTop: 0 }, 1000, attachScrollHandler );
  }

  function attachScrollHandler() {
    $window.on('scroll' + namespace, $.throttle(50, requestAnimationFrame.bind(window, onScroll)) ); 
  }

  function removeScrollHandler() {
    $window.off('scroll' + namespace);
  }

  function init() {
    if(initialized) return;

    if($btn.length) {
      $btn.on('click', onBtnClick);
      attachScrollHandler();
      requestAnimationFrame.bind(window, onScroll);
    }

    initialized = true;
  }

  return {
    init: init
  };
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * - Attaches the `Product` constructor to window.theme.Product.
 * - Also defines the ProductImageZoomController class which is consumed exclusively by the Product class.
 *
 * Requires:
 *  - jQuery
 *  - jQuery.fn.zoom - http://www.jacklmoore.com/zoom/
 *  - Slate
 *  - theme.strings (see layout/theme.liquid)
 *  - Modernizr
 *
 * @namespace product
 */

theme.Product = (function($, slate, theme, Modernizr) {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productGallery: '[data-product-gallery]',
    productGalleryFeatured: '[data-product-gallery-featured]',
    productGalleryThumbnail: '[data-product-gallery-thumbnail]',
    productGalleryThumbnailSlide: '[data-product-gallery-thumbnail-slide]',
    productFeaturedImageWrapper: '[data-product-featured-image-wrapper]',
    productFeaturedImageLink: '[data-product-featured-image-link]',
    productFeaturedImage: '[data-product-featured-image]',
    initialSlide: '[data-initial-slide]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    singleOptionSelector: '[data-single-option-selector]',
    optionLabelValue: '[data-single-option-label-value]',
    openModal: '[data-open-size-guide]',
    closeModal: '[data-close-size-guide]',
    sizeGuideModal: '[data-size-guide]',
    productVariantList: '[data-variant-list]',
    productVariant: '[data-variant]',
    swatch: '[data-swatch]',
    variantOptionValue: '[data-variant-option-value]'
  };


  // special product pages
  var isManyProductPage = document.getElementById("manyvariant");
  if(isManyProductPage){
   

    function loadSwatches(){


      $('.product-swatches').each(function(i, product) {
        
          var productId = $(product).data('productId');
          var styleNo = $(product).data('styleNumber');

          
          // search for other products with the same style number and dimension
          var url = '/search?type=product&view=json&q=tag:' + styleNo;

          $.getJSON(url, function(data) {
            var otherColors = data.results;
            

            var swatchList = $(product).find('ul');
            var swatchTemplate = $(product).find('.product-swatch-template');
            
            // We need to count other avilible colors
            howManyOthers = 0;
    
            otherColors.forEach(function(p) {
              if(p.available){
    
                // We need to count other avilible colors
                howManyOthers = howManyOthers + 1;

                var item = swatchTemplate.clone();
          
                if(p.id == productId){
                  item.addClass('is-active');
                }
          
                item.removeClass('.product-swatch-template');
                item.find('a').attr('href', p.url);
                var image = item.find('img');
                image.attr('src', p.thumbnail);

                item.find('.Swatches__swatch-label').text( p.alt );
          
                swatchList.append(item);
    
              }          
            });
            
  
            swatchTemplate.remove();
            swatchList.show();

              
          });
      });
    }

    loadSwatches();

  }


  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.name = 'product';
    this.namespace = '.'+this.name;
    this.firstLoad = false;

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject  = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize   = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
    this.settings.zoomEnabled = this.$container.data('zoom-enabled'); // $.data coerces to boolean whereas $.attr('data-*') doesn't

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
    this.initSizeGuide();
    this.initGalleries();

    this.$container.on('click', selectors.swatch, this.onSwatchClick.bind(this));
    this.$container.on('click', selectors.variantOptionValue, this.onVariantOptionValueClick.bind(this));
    //jQuery('ul.Swatches__list li.is-active').click();
    jQuery('.Tag-list .Tag.is-active').click();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
     
    },

    initGalleries: function() {
    
      var self = this;
      var $galleries = $(selectors.productGallery);
      var $firstLoad = '';
      var zoomReadyClass = 'is-zoomable';
      var zoomedInClass  = 'is-zoomed';
      var variantsAvailableStr = JSON.stringify(self.variants.product.variants);
      // Lifecycle methods for handling slideshow changes + hoverzoom initialization
      function initHoverZoom($zoomTarget) {
        var opts = {
          url: $zoomTarget.find(selectors.productFeaturedImageLink).attr('href'),
          on: 'mouseover',
          touch: false,
          escToClose: true,
          zoomMagnify: 0.8,
          zoomDuration: 300,
          callback: function() {
            $zoomTarget.addClass(zoomReadyClass);
            // Immediately trigger zoom if we're already hovering over the image
            // Otherwise we have to mouseout and mousein again
            // this data attribute is set below when we initialize the gallery
            if($zoomTarget.data('mouseover')) {
              $zoomTarget.trigger('mouseover');
            }
          },
          onZoomIn: function() {
            $zoomTarget.addClass(zoomedInClass);
          },
          onZoomOut: function() {
            $zoomTarget.removeClass(zoomedInClass);
          }
        };

        $zoomTarget.zoom(opts);
      }

      function destroyHoverZoom($zoomTarget) {
        $zoomTarget.trigger('zoom.destroy');
      }

      function onFeaturedSlickBeforeChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.zoomEnabled) {
          destroyHoverZoom($zoomTarget);
        }
      }

      function onFeaturedSlickAfterChange(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.zoomEnabled) {
          initHoverZoom($zoomTarget);
        }
      }

      function onFeaturedSlickInit(e, slick) {
        var $zoomTarget = $(slick.$slides[ slick.currentSlide ]);
        if(self.settings.zoomEnabled) {
          initHoverZoom($zoomTarget);
        }
      }

      $galleries.each(function() {
        var $featured  = $(this).find(selectors.productGalleryFeatured);
        var $thumbnail = $(this).find(selectors.productGalleryThumbnail);

        // Look for element with the initialSlide selector.
        var initialSlide = $(this).find(selectors.initialSlide).length ? $(this).find(selectors.initialSlide).index() : 0;

        $featured.on({
          init:         onFeaturedSlickInit,
          beforeChange: onFeaturedSlickBeforeChange,
          afterChange:  onFeaturedSlickAfterChange,
        });

        // Keep track of when a featured image is being hovered over
        // We'll use this info to trigger hoverzoom immediately if true
        $featured.on('mouseenter', selectors.productFeaturedImageWrapper, function() {
          $(this).data('mouseover', true);
        });
        $featured.on('mouseleave', selectors.productFeaturedImageWrapper, function() {
          $(this).data('mouseover', false);
        });

        $featured.slick({
          speed: 600,
          dots: true, // hide these on desktop via css
          swipe: Modernizr.touchevents,
          arrows: !Modernizr.touchevents,
          asNavFor: '#' + $thumbnail.attr('id'),
          initialSlide: 0
        });

        var sildeNum = 10;
        var foundSlideNum = $thumbnail.find(selectors.productGalleryThumbnailSlide).length;
        if(foundSlideNum == 3 || foundSlideNum == 4) {
          sildeNum = 4;
        }
        else {
          sildeNum = foundSlideNum;
        }

        $thumbnail.slick({
          speed: 600,
          slidesToShow: sildeNum, // Slick has trouble when slidesToShow = slide number
          slidesToScroll: 1,
          asNavFor: '#' + $featured.attr('id'),
          initialSlide: initialSlide
        });

        $thumbnail.on('click', selectors.productGalleryThumbnailSlide, function() {
          $featured.slick('slickGoTo', $(this).data('slick-index'));
        });
      });

      // Because slick can get weird on initialization, make sure we call `refresh` on any visible galleries
      $galleries.not('.hide').each(function() {
        var $variantGallery = $(this);
        $variantGallery.find(selectors.productGalleryFeatured).slick('getSlick').refresh();
        $variantGallery.find(selectors.productGalleryThumbnail).slick('getSlick').refresh();
      });

      // Variant change callback.
      // Look for a gallery matching one of the selected variant's options and switch to that gallery
      // If a matching gallery doesn't exist, look for the variant's featured image in the main gallery and switch to that
      this.$container.on('variantChange',function(e){
        var variantsAvailable = JSON.parse(variantsAvailableStr);
        //setTimeout(function(){ 
        var variant = e.variant;
        var sizePos = null;
        var firstLoadA = false;
        if( $firstLoad != e.variant.option1){
          firstLoadA = true;
          $firstLoad = e.variant.option1;
        }
      
        $.each(self.variants.product.options, function( index, value ) {
          if(value == 'Size'){
            sizePos = index;
            return false;
          }
        });
       
        var varationsObj = new Array();
        for(var i=0; i<variantsAvailable.length;i++){
          if(JSON.stringify(variantsAvailable[i].options).indexOf(variant.option1) != -1){
           varationsObj.push({available:variantsAvailable[i].available, size: JSON.stringify(variantsAvailable[i].options) });
          }
        }
      

        //check if sizes enabled
        var variablesAvailable = variant.options;
      
        var firstAvailable = false;
        var tagsHtml = new Array();
        $(".Tag-list .Tag").each(function() {
          variablesAvailable[sizePos] = $(this).attr('data-variant-option-value');
          tagsHtml.push({currentSize: $(this),size: JSON.stringify(variablesAvailable) });
        });

        firstLoop:
        for(var y=0; y<tagsHtml.length;y++){
          var currentSize = tagsHtml[y].currentSize;

          for(var i = 0; i<varationsObj.length;i++){
            if( tagsHtml[y].size ==  varationsObj[i].size ){
              
              if(varationsObj[i].available){
                currentSize.removeClass('is-unavailable');
                if(!firstAvailable && variant.available == false && firstLoadA){ 
                  firstAvailable = currentSize; 
                  break firstLoop;
                }
              }else{ 
              
                currentSize.addClass('is-unavailable');
              }  
            }
          }
        }

        if(firstAvailable){
          
          $("#BIS_trigger").hide(100);
          setTimeout(function(){$(firstAvailable).click(); }, 500);
          e.preventDefault();
          return;
        }
       
        //show form back in stocks
        if(typeof BIS !== 'undefined'){
          if(!variant.available){
            $("#BIS_trigger").fadeIn().attr('data-variant-id', variant.id);
          }else{
            $("#BIS_trigger").hide(100);
          }
        }

        if(variant) {
          if($galleries.length > 1) {
            for (var i = 3; i >= 1; i--) {
              var option = variant['option' + i];
              var $variantGallery = $galleries.filter(function() {
                return $(this).data('variant-gallery') == option;
              });

              if($variantGallery.length && $variantGallery.hasClass('hide')) {
                $galleries.not($variantGallery).addClass('hide');
                $variantGallery.removeClass('hide');
                // Slick needs to make a lot of measurements in order to work, calling `refresh` forces this to happen
                $variantGallery.find(selectors.productGalleryFeatured).slick('getSlick').refresh();
                $variantGallery.find(selectors.productGalleryThumbnail).slick('getSlick').refresh();
              }
            }
          }
          else {
            if(variant.featured_image) {
              var $imageSlide =  $(selectors.productGalleryFeatured).find('[data-image='+variant.featured_image.id+']').first();

              if($imageSlide.length) {
                $imageSlide.parents(selectors.productGalleryFeatured).slick('slickGoTo', $imageSlide.data('slick-index'));
              }
            }
          }
        }
        //}, 1000);
      });
    },

    /**
     * Handles click on alternative UI elements that respresent variant options.
     * Finds their associated singleOptionselector and trigger a change event on it.
     * Requires clicked on element to
     *   - Respond to 'is-active' class
     *   - Be nested inside an element matching `selectors.productVariantList` with data attribute `option-position`
     *   - Have sibling elements of the same type (clicked on element shouldn't be nested inside sibling elements)
     *
     * @param {jQuery} $el
     * @param {string} value
     */ 
    onAltUIVariantOptionClick: function($el, value) {
      var activeClass = 'is-active';

      if ($el.hasClass(activeClass) && this.firstLoad) { 
        return;
      }

      this.firstLoad = true;
      var position  = $el.parents(selectors.productVariantList).data('option-position');
      var $selector = $(selectors.singleOptionSelector).filter('[data-index="option'+position+'"]');

      $selector.val(value);
      $selector.trigger('change');

      $el.siblings().removeClass( activeClass );
      $el.addClass( activeClass );

      $el.parents('.selector-wrapper').find( selectors.optionLabelValue ).text(value);
    },

    /**
     * Handles click event on swatch element
     *
     * @param {event} e
     */   
    onSwatchClick: function(e) { 
      this.firstLoad = true;
      
      this.firstLoad
      var $swatch = $(e.currentTarget);
      var value   = $swatch.data('swatch');
      this.onAltUIVariantOptionClick($swatch, value);
    },

    /**
     * Handles click event on variant option value
     *
     * @param {event} e
     */
    onVariantOptionValueClick: function(e) {
      e.preventDefault();
      var $option = $(e.currentTarget);
      var value = $option.data('variant-option-value');

      this.onAltUIVariantOptionClick($option, value);
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    initSizeGuide: function() {

      var isActive = 'is-active';
      var hideOverflow = 'u-ofy-hidden';

      var openSizeGuideModal = function() {
        $(selectors.sizeGuideModal).addClass(isActive);
        $(document.body).addClass(hideOverflow);
      }

      var closeSizeGuideModal = function() {
        $(selectors.sizeGuideModal).removeClass(isActive);
        $(document.body).removeClass(hideOverflow);
      }

      $(selectors.openModal).on('click', function(e){ e.preventDefault(); openSizeGuideModal(); });
      $(selectors.closeModal).on('click', closeSizeGuideModal);

      $(document).on('keyup',function(e) {
        if (e.keyCode == 27 && $(selectors.sizeGuideModal).hasClass(isActive)) {
          closeSizeGuideModal();
        }
      });
    }
  });

  return Product;
})(jQuery, slate, theme, Modernizr);
/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 */

theme.Collection = (function($, slate) {

  var selectors = {
    sidebarBlock: '.Sidebar-block',
    filterControlToggle: '[data-collection-filter-control-toggle]',
    filterBlock: '[data-collection-filter-block]'
  };


if($('body').hasClass('template-collection')){
  function loadSwatches(){


    $('.product-swatches').each(function(i, product) {
      
        var productId = $(product).data('productId');
        var styleNo = $(product).data('styleNumber');

        
        // search for other products with the same style number and dimension
        var url = '/search?type=product&view=json&q=tag:' + styleNo;

        $.getJSON(url, function(data) {
          var otherColors = data.results;
          

          var swatchList = $(product).find('ul');
          var swatchTemplate = $(product).find('.product-swatch-template');
          
          // We need to count other avilible colors
          howManyOthers = 0;
          var showMore = '<li class="Swatches__swatch" data-swatch-overflow-toggle=""><div class="Swatches__swatch-bg Swatches__swatch-bg--no-border"><a href="#" class="Swatches__swatch-link" title="More colors available">+</a></div></li>';

  
          otherColors.forEach(function(p) {
            if(p.available){
  
              // We need to count other avilible colors
              howManyOthers = howManyOthers + 1;

              var item = swatchTemplate.clone();
        
              // if(p.id == productId){
              //   item.addClass('is-active');
              // }
        
              item.removeClass('.product-swatch-template');
              var swatchLink =  item.find('a');
              swatchLink.attr('href', '#');

             // swatchLink.attr('data-featured', p.featured_image);
              
              swatchLink.on( "click", function(event) {
                event.preventDefault();

                
                var swatchItem = $(this).closest('.Swatches__swatch');
                var swatchImage = $(this).closest('.flex-col');
                var productLink = $(swatchImage).children('a');
                var swatchImageFind = $(swatchImage).find('.Product-thumbnail-image');
                var productTitleLink = $(swatchImage).find('.Product-thumbnail__details').children('a');
                
                // remove selected class from any others
                $(swatchItem).siblings().each( function () {
                  $(this).removeClass('is-active');
                });
                // add selected class to this item
                swatchItem.addClass('is-active');
                swatchImageFind.attr('src', p.featured_image);
                productLink.attr('href', p.url);
                productTitleLink.attr('href', p.url);
              });

              var image = item.find('img');
              image.attr('src', p.thumbnail);

              item.find('.Swatches__swatch-label').text( p.alt );


              swatchList.append(item);

             if (otherColors.length > 4 && howManyOthers == otherColors.length){
                swatchList.append(showMore);
              }
            }          
          });

          swatchTemplate.remove();
          swatchList.show(); 
        });
    });
  }

  function yotpoLinkReplace() {
    setTimeout(function(){
        $('.Collection-grid__item').each(function(){
          var hasYotpoLinks = $(this).find('.yotpo-bottomline');
          var productCol = $(this).find('.flex-col');
          var productLink = $(productCol).children('a').attr("href");
          productLink = $.trim(productLink);
          var reviewLink = productLink + '#reviews';
      
          if(hasYotpoLinks.length !== 0){
            var yotpoLink = $(hasYotpoLinks).find('.text-m');
            $(yotpoLink).attr('href', reviewLink)
          }
      });
    }, 3000);
  }

  yotpoLinkReplace();
  loadSwatches();
}
 

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.name = 'collection';
    this.namespace = '.'+this.name;

    slate.ProductThumbnails.init();

    $(selectors.filterControlToggle).on('click', function(e){
      e.preventDefault();
      $(this).toggleClass('is-open');
      $(selectors.filterBlock).toggleClass('hidden-xs');
      $(selectors.filterBlock).toggleClass('hidden-sm');
    })

  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    //
  });

  return Collection;
  
})(jQuery, slate);

/**
 * Pencil Banner Section Script
 * ------------------------------------------------------------------------------
 * Exposes methods and events for the opening and closing of the banner
 *
 * @namespace - pencilBanner
 */

theme.PencilBanner = (function($) {

  var selectors = {
    close: '[data-pencil-banner-close]'
  };

  /**
   * Pencil Banner section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function PencilBanner(container) {
    this.$container = $(container);

    this.name = 'pencilBanner',
    this.namespace = '.'+this.name;

    this.events = {
      SHOW: 'show'   + this.namespace,
      CLOSE: 'close' + this.namespace
    };

    $(selectors.close).on('click', this.close.bind(this));
  }

  PencilBanner.prototype = $.extend({}, PencilBanner.prototype, {

    /**
     * Allows you to run specific code when viewing this section inside the theme editor for a more pleasant experience
     * To use, call this at the end of the constructor method
     */
    initForThemeEditor: function() {
      var insideThemeEditor = location.href.match(/myshopify.com/) && location.href.match(/theme_id/);
     
      if(insideThemeEditor){
        // Hide the close button to make life simpler
        // $(selectors.close).hide();
      }
    },

    /**
     * Generates a string of integers unique to the text contents of the banner
     * Useful for setting a cookie associated with the banner that invalidates when the contents are changed
     * Reference - https://stackoverflow.com/a/7616484
     *
     * @return {string}
     */
    generateHashCodeForText: function() {
      var str = this.$container.text();
      var hash = 0, i, chr;

      if (str.length === 0) return hash;

      for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash  = hash & hash; // Convert to 32bit integer
      }
      return Math.abs(hash).toString();
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to show the banner
     */
    show: function() {
      console.log('['+this.name+'] - open');
      $(window).trigger( $.Event(this.events.SHOW) );
    },

    /**
     * STUB METHOD - You need to add implementation details
     * Call this to close the banner
     */
    close: function() {
      console.log('['+this.name+'] - close');
      $(window).trigger( $.Event(this.events.CLOSE) );
    },

    onCloseClick: function(e){
      e.preventDefault();
      this.close();
    },

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      console.log('['+this.name+'] - section:select');
    },

    onShow: function() {
      console.log('['+this.name+'] - section:show');
    },

    onLoad: function() {
      console.log('['+this.name+'] - section::load');
    },

    onUnload: function() {
      console.log('['+this.name+'] - section::unload');
    }
  });

  return PencilBanner;
})(jQuery);

theme.Slider = (function($){

  var selectors = {
    slider: '[data-slider]',
    slides: '[data-slide]'
  }

  function Slider(container){

    this.$container = $(container);

    this.name = 'slider';
    this.namespace = '.'+this.name;

    this.settings = {
      slide: selectors.slides,
      dotsClass: 'slick-dots',
      autoplay : true,
      slidesToshow : 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      useCSS: false
    };

    this.settingsCentered = {
      slide: selectors.slides,
      dotsClass: 'slick-dots flex flex-justify-center',
      slidesToshow : 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      useCSS: false,
      centerMode: true,
      centerPadding: '20%',
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 576,
          settings:{
            centerMode: false,
            dots: true,
            arrows: false
          }
        }
      ]
    }

    this.onUnload();
  }

  Slider.prototype = $.extend({}, Slider.prototype, {

    onUnload: function() {
      var $slider = $(selectors.slider);
      var $slides = $(selectors.slides, this.$container);

      function playVideo(slick,currentSlide){
        if(currentSlide.hasClass('video-slide')){
          currentSlide.find('video').get(0).play();
        };
      }

      $slider.on('init', function (event, slick, currentSlide) {
        var currentSlide = $(slick.$slides.get(currentSlide));
        playVideo(slick, currentSlide);
      });

      $slider.on('afterChange',function (event, slick, currentSlide) {
        var currentSlide = $(slick.$slides.get(currentSlide));
        playVideo(slick, currentSlide);
      });

      if( $slides.length > 1 && !$slider.hasClass("highlighted-post")){
          $slider.slick(this.settings);
        }else if($slider.hasClass("highlighted-post")){
          $slider.slick(this.settingsCentered);
        }
      }
  });

  return Slider;
})(jQuery, slate)

/**
 * Footer Script
 * ------------------------------------------------------------------------------
 */

theme.Footer = (function($) {

  var selectors = {
    menuToggleSelect: '[data-toggle-footer-nav]'
  };

  function Footer(container) {
    this.$container = $(container);

    var activeMenuAnimation = 'footer__linklist-header-mobile-active';

    $(selectors.menuToggleSelect).on('click', function(){
       
      var toggledMenu = $(this).next('ul');
       
      $(toggledMenu).slideToggle();
      $(this).toggleClass(activeMenuAnimation);
   
    });
  }
 
  return Footer;

})(jQuery);

/**
 * FAQs Script
 * ------------------------------------------------------------------------------
 */

 theme.Faq = (function($){

  var selectors = {
    menuToggleSelect: '[js-data-toggle-faq-item]'
  }

  function Faq(container) {
    this.$container = $(container);

    var activeMenuAnimation = 'faq__list-item-header-active';

    $(selectors.menuToggleSelect).on('click', function(){
       
      console.log('clock');

      var toggledMenu = $(this).next('div.faq__list-item-content');
       
      $(toggledMenu).slideToggle();
      $(this).toggleClass(activeMenuAnimation);
    });
  }

  return Faq;

 })(jQuery);
 
theme.imageHover = (function($){

  var currentGallery = false;
  var timeoutImageGallery = null;
  var currentHover = null;
  var activeQueue = new Array();
  $(".containerslick").hover(function() {
      
      if(currentHover && currentHover == $(this) ) return false;
      if($(this).children('.auto-gallery').children().length == 0 || $(this).children('.auto-gallery').children().length == $(this).children('.auto-gallery').children('.variant').length)return false;
      var targetSlick = $(this).children('.slickhover');
      // stop all running slicks
      if( $('.slickhover.slick-initialized').length>1){
        
        $('.slickhover.slick-initialized').each(function( index ,val) {
          if(targetSlick[0] == val) return true;
          $(val).slick('slickUnfilter');
          $(val).slick('slickFilter','.Product-thumbnail-image');
        });
      }
     
      var active  = $(this).parent().next().find('li.is-active').attr("data-swatch");
      var activeCount = 0;
      if(!active){
        //select first swatch
        active  = $(this).parent().next().find('li:first').attr("data-swatch");
        $(this).parent().next().find('li:first').addClass('is-active');
        activeQueue.push(active);
      }
      
      currentHover = $(this);
    
      if( $(targetSlick).hasClass('slick-initialized') ){
        targetSlick.slick('slickUnfilter');
        targetSlick.slick('slickPlay');
      }else{
        //create slick
        targetSlick.slick({
          speed: 200,
          autoplay:true,
          autoplaySpeed:900,
          fade:true,
          infinite:true,
          arrows: false,
        });
        
        var html ='';
        $(this).children('.auto-gallery').children().each(function( index ) {
          var cls = $( this ).attr('class');
          if(index == 0){
            cls = '.Product-thumbnail-image';
          }
          html+='<img src="' + $( this ).attr('src') + '" class="' + $( this ).attr('class') + '" alt=""/>';
          if(active && $( this ).attr('class') == 'v_'+active.toLowerCase().replace(' ','-')){
            activeCount++;
          }
        });

        targetSlick.slick('slickAdd', html);
       
      }
      targetSlick.slick('slickGoTo',1);
      if(active){
        targetSlick.slick('slickFilter','.v_'+active.toLowerCase().replace(' ','-'));
      }else{
        targetSlick.slick('slickFilter','.variant');
      }

    
    }, function() { // on  stop hover
      
      if(!$(this).children('.slickhover').hasClass('slick-initialized')) return false;
      $(this).children('.slickhover').slick('slickUnfilter');
      $(this).children('.slickhover').slick('slickFilter','.Product-thumbnail-image');
      var active  = $(this).parent().next().find('li.is-active').attr("data-swatch");
      if(activeQueue.length && active){
        for(var i = 0;i<activeQueue.length;i++){
          if(activeQueue[i] == active){
            $(this).parent().next().find('li:first').removeClass('is-active');
            activeQueue.splice(i,1);
          }
        }
      }
    }
  );

})(jQuery, slate)
/**
 * Header Script
 * ------------------------------------------------------------------------------
 */

theme.Header = (function($) {

  //manage search
  var searchExtended  = false;
  $(".icon-search").click(function() {
    if(searchExtended){
      
      if($("#SearchDesktop").val().length>0){
        $("#mainSearchForm").submit();
      }
      hideSearchInput();
    }else{
      searchExtended = true;
      $(".site-header__search-wrap").addClass("noline");
      $("#searchfield-container").css('display','block');
      $("#SearchDesktop").focus();
      $("#searchfield-container").animate({    opacity: 1}, 500, function() {     });
    }
    
  });
  
  $("#SearchDesktop").click(function(e) {
     e.stopPropagation();
  });

  $("body").click(function(e) { 
   if( $(".rfk_visible").length == 1 && searchExtended && $("#SearchDesktop").val().length == 0){
     hideSearchInput();
    }
  });

  function hideSearchInput(){
     searchExtended = false;
      $(".site-header__search-wrap").removeClass("noline");
      $("#searchfield-container").hide();
      $("#searchfield-container").animate({    opacity: 0  }, 500, function() {     });
  }
  

})(jQuery);


/*================ Templates ================*/
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#RecoverPassword').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Collection page filterings
 */

slate.filter = (function () {
  var selectors = {
    // Filters
    filterMainContainer: '.js-filter-main-container',
    filterAction: '.js-filter-action',
    filterContainer: '.js-filter-container',
    filterPopover: '.js-filter',
    filterSelect: '.js-filter-select',
    filterClear: '.js-filter-clear',
    // Mobile Filters
    mobileHidden: '.js-mobile-hidden',
    mobileFiltersToggle: '.js-mobile-filter-toggle',
    mobileModalContainer: '.js-mobile-filter-modal',
    mobileFilterContainer: '.js-mobile-filter-container',
    mobileFilterClose: '.js-modal-filter-close',
    mobileInsertAfter: '.js-mobile-after',
  };

  var collectionData = window.theme.collectionData;

  if (!collectionData) return;

  var activeClass = 'is-active';
  var hiddenClass = 'hidden';
  var scrollClass = 'u-overflow-hidden';

  var DESKTOP_MIN_WIDTH = 992;

  function preventDefault (fn) {
    return function (evt) {
      evt.preventDefault();
      return fn.call(this, evt);
    };
  }

  function getCollectionUrlWithFilters () {
    var collectionUrl = collectionData.url;
    var tags = [];

    $(selectors.filterSelect).filter('.' + activeClass).each(function () {
      tags.push($(this).data('value'));
    });

    tags = tags.map(function (str) {
      return str
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    });

    return tags.length ? collectionUrl + '/' + tags.join('+') : collectionUrl;
  }

  function getQueryParams () {
    var queryString = location.search && location.search.substr(1) || '';
    var queryParams = {};

    queryString
      .split('&')
      .filter(function (element) {
        return element.length;
      })
      .forEach(function (paramValue) {
        var splitted = paramValue.split('=');

        if (splitted.length > 1) {
          queryParams[splitted[0]] = splitted[1];
        } else {
          queryParams[splitted[0]] = true;
        }
      });

    return queryParams;
  }

  var Filters = {
    toggleVisibility: function toggleVisibility () {
      var self = $(this);
      var option = $(this).data('option');

      $(selectors.filterPopover).filter('.' + activeClass).each(function () {
        var callToAction = $(this)
                              .parents(selectors.filterContainer)
                              .find(selectors.filterAction);

        if (!callToAction.is(self)) {
          Filters.toggleVisibility.call(callToAction);
        }
      });

      $(this)
        .toggleClass(activeClass)
        .parents(selectors.filterContainer)
        .find(selectors.filterPopover)
        .toggleClass(activeClass);
    },
    selectFilter: function selectFilter () {
      var selectedOption = $(this).text();

      $(this)
        .parents(selectors.filterPopover)
        .find('.' + activeClass)
        .removeClass(activeClass);

      $(this).addClass(activeClass);

      $(this)
        .parents(selectors.filterContainer)
        .find(selectors.filterAction)
        .text(selectedOption)
        .removeClass(activeClass)
        .parents(selectors.filterContainer)
        .find(selectors.filterPopover)
        .removeClass(activeClass);

      // Trigger filtering action right away
      Filters.doFilter();
    },
    doFilter: function doFilter () {
      var collectionUrl = getCollectionUrlWithFilters();
      var queryParams = getQueryParams();

      window.location.href = collectionUrl + '?' + $.param(queryParams);
    },
    clearFilters: function clearFilters () {
      var collectionUrl = collectionData.url;
      var queryParams = getQueryParams();

      window.location.href = collectionUrl + '?' + $.param(queryParams);
    },
    checkMobileFiltersStatus: function () {
      var activeFilters = $('.Filter-modalContent').find('.js-filter-select.is-active');

      if (activeFilters.length > 0) {
        $('#clear-filter-btn').addClass('active');
        $('#zero-indicator').removeClass('active');
        $('.Select.Select--filter.filter--mobile.u-mr__md').find('.js-mobile-filter-toggle').text('Filter By (' + activeFilters.length + ')')
      } else {
        $('#clear-filter-btn').removeClass('active');
        $('#zero-indicator').addClass('active');
      }
    },
    checkSize: function () {
      var width = $(window).width();

      if (width < DESKTOP_MIN_WIDTH) {
        this.moveForMobile();
        this.checkMobileFiltersStatus();
      } else {
        this.moveForDesktop();
      }
    },
    moveForMobile: function () {
      $(selectors.mobileHidden).addClass(hiddenClass);
      $(selectors.mobileFiltersToggle).removeClass(hiddenClass);

      $(selectors.filterContainer)
        .detach()
        .appendTo(selectors.mobileFilterContainer);
    },
    moveForDesktop: function () {
      $(selectors.mobileHidden).removeClass(hiddenClass);
      $(selectors.mobileFiltersToggle).addClass(hiddenClass);

      $(selectors.filterContainer)
        .detach()
        .insertAfter(selectors.mobileInsertAfter);
    },
    openModal: function () {
      $(selectors.mobileModalContainer).removeClass(hiddenClass);
      $('body').addClass(scrollClass);
    },
    closeModal: function () {
      $(selectors.mobileModalContainer).addClass(hiddenClass);
      $('body').removeClass(scrollClass);
    },
    init: function () {
      // Sort Filters
      $(selectors.filterPopover).each(function () {
        var container = $(this).find('.Content .flex');
        var toSort =  container.find('.js-Filter-item');

        toSort.sort(function (a, b) {
          var contentA = $(a).find(selectors.filterSelect).text().trim();
          var contentB = $(b).find(selectors.filterSelect).text().trim();

          if (!isNaN(parseInt(contentA))) {
            contentA = Number(contentA);
            contentB = Number(contentB);
          }

          if (contentA < contentB) {
            return -1;
          }

          if (contentA > contentB) {
            return 1;
          }

          return 0;
        });

        toSort.detach().appendTo(container);
      });

      // Prevent Closing
      $('body').on('click', function (evt) {
        if ($(selectors.filterPopover).hasClass(activeClass) &&
          !$(evt.target).is(selectors.filterPopover + ', a') &&
          !$(evt.target).closest(selectors.filterPopover).length) {

          $(selectors.filterPopover).filter('.' + activeClass).each(function () {
            var callToAction = $(this)
                                  .parents(selectors.filterContainer)
                                  .find(selectors.filterAction);

            Filters.toggleVisibility.call(callToAction);
          });
        }
      });

      $(window).on('resize', this.checkSize.bind(this));
      this.checkSize(); // First Launch

      // Actions
      $('body').on('click', selectors.filterAction, preventDefault(Filters.toggleVisibility));
      $('body').on('click', selectors.filterSelect, preventDefault(Filters.selectFilter));
      $('body').on('click', selectors.filterClear, preventDefault(Filters.clearFilters));

      // Mobile Only
      $('body').on('click', selectors.mobileFiltersToggle, preventDefault(Filters.openModal));
      $('body').on('click', selectors.mobileFilterClose, preventDefault(Filters.closeModal));
    }
  };

  Filters.init();
}());

slate.caruosels = (function() {

  var selectors = {
  	carouselContainer: '[data-js-carousel-container]',
    carousel: '.js-carousel-container',
    activeHoverNavItem: '.site-nav--has-submenu'
  };

  function makeCarousel () {
    $(selectors.carouselContainer).each(function () {
      var actualCarousel = $(this).find(selectors.carousel);
	    actualCarousel.slick({
        adaptiveHeight: true,
        autoplay : true,
        arrows: false,
        dots: true
      });
    });
  }

  makeCarousel();

}());
slate.search = (function(){
  
  var $document = $(document);
  var $body = $(document.body);

  var selectors = {
    openModalLink: '[data-js-search-modal-link]',
    closeModalLink: '[data-js-close-modal-link]',
    modalWindow: '[data-js-modal-window]',
    searchInput: '.search-modal__input',
    searchContainer: '.search-modal__wrap'
  };

  var fadeOutClass = 'js-modal__hide-fade-out';
  var fadeInClass = 'js-modal__hide-fade-in';

  function preventDefault(fn) {
    return function(evt) {
      evt.preventDefault();
      return fn.call(this, evt);
    };
  }

  function openModalWindow(evt) {
    var $modal = $(selectors.modalWindow);
    $modal.addClass(fadeInClass);
    $modal.one('transitionend', function(){
      $(this).find(selectors.searchInput).focus();
    });

    $body.css('overflow', 'hidden');
  }

  function closeModalWindow(evt) {
    var $modal = $(selectors.modalWindow);
    $modal.removeClass(fadeInClass);
    $modal.one('transitionend', function(){
      $(this).find(selectors.searchInput).focus();
    });
    $body.css('overflow', 'auto');
  }

  $document.on('keyup',function(evt) {
    if (evt.keyCode == 27) {
      closeModalWindow();
    }
  });

  $(selectors.closeModalLink).on("click", (function(){
    preventDefault(closeModalWindow());
  }));

  $(selectors.openModalLink).on("click", (function(){
    preventDefault(openModalWindow());
  }));

}());

slate.mobileNavigation = (function(){
  var selectors = {
    mobileNavContainer: '[data-js-mobile-nav-container]',
    openMobileLink: '[data-js-open-mobile-nav]',
    closeMobileLink: '[data-js-close-mobile-nav-link]',
    closeMobileContainer: '[data-js-close-mobile-nav]',
    mobileLinkList: '#site-mobile-nav',
    submenuLink: '[data-js-submenu-slide-in]',
    submemuTargetList: '[data-js-submenu-target]',
    submenuCloseLink: '[data-js-submenu-close]',
    pencileBannerId: '#shopify-section-pencil-banner'
  };

  var navAnimationClass = 'site-mobile-nav__menu-active';
  var navBgAnimationClass = 'site-mobile__link-wrap-exit-active';
  var navSubmenuAnimationClass = 'site-mobile-nav__slide-in-container-active';
  var navSubmenuSlugClassPrefix = 'site-mobile-nav__submenu-link-';
  var navSubmenuListClassPrefix = 'site-mobile-nav__submenu-list-';

  //Add needed extra space to top of meny on mobile if pencil banner is used
  var pencileBanner = $(selectors.pencileBannerId);
  // Wait until pencil banner is loaded
  setTimeout(function(){ 
    var pencileBannerHeight = pencileBanner.height();
    var topOffset = pencileBannerHeight + 60
    var topOffsetPx = topOffset + 'px';
    var heightPx =  'calc(100% - ' + topOffsetPx + ')'
    $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx});

    if ($(window).width() < 992) {
      $(window).scroll(function (event) {

        var scrolledFromTop = $(window).scrollTop();
        var howFarScrolled = pencileBannerHeight - scrolledFromTop + 60;

        if(scrolledFromTop < pencileBannerHeight) {
          var topOffset = howFarScrolled;
          var topOffsetPx = topOffset + 'px';
          var heightPx =  'calc(100% - ' + topOffsetPx + ')'
          $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx});
        }
        else {
          if($(selectors.mobileNavContainer).css('top') !== '60px'){
            var topOffsetPx = '60px';
            var heightPx =  'calc(100% - ' + topOffsetPx + ')'
            $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx});
          }
        }
      })
    }

  }, 2000);

  // Open Mobile Menu
  $(selectors.openMobileLink).on('click', (function(){
    var pencileBannerHeight = pencileBanner.height();
    var scrolledFromTop = $(window).scrollTop();
    if(scrolledFromTop !== 0) {   
      if(scrolledFromTop > pencileBannerHeight) {
        var topOffsetPx = '60px';
        var heightPx =  'calc(100% - ' + topOffsetPx + ')'
        $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx}); 
      }
      else{
        var howFarScrolled = pencileBannerHeight - scrolledFromTop + 60;
        var topOffset = howFarScrolled;
        var topOffsetPx = topOffset + 'px';
        var heightPx =  'calc(100% - ' + topOffsetPx + ')'
        $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx});
      }
    }
    else {
      var pencileBannerHeight = pencileBanner.height();
      var topOffset = pencileBannerHeight + 60
      var topOffsetPx = topOffset + 'px';
      var heightPx =  'calc(100% - ' + topOffsetPx + ')'
      $(selectors.mobileNavContainer).css({'top' : topOffsetPx, 'height' : heightPx, 'min-height' : heightPx});
    }

    $(this).hide();
    $(selectors.closeMobileLink).show();
    $(selectors.closeMobileContainer).addClass(navBgAnimationClass);
    $(selectors.mobileNavContainer).addClass(navAnimationClass);
    $('html, body').addClass('body-mobile-menu');
  }));
  
  // Close Mobile Menu Link
  $(selectors.closeMobileLink).on('click', (function(){
    $(this).hide();
    $(selectors.openMobileLink).show();
    $(selectors.closeMobileContainer).removeClass(navBgAnimationClass);
    $(selectors.mobileNavContainer).removeClass(navAnimationClass);
    $('html, body').removeClass('body-mobile-menu');
  }));

  // Close Mobile Menu
  $(selectors.closeMobileContainer).on('click', (function(){
    $(selectors.closeMobileLink).hide();
    $(selectors.openMobileLink).show();
    $(selectors.closeMobileContainer).removeClass(navBgAnimationClass);
    $(selectors.mobileNavContainer).removeClass(navAnimationClass);
    $('html, body').removeClass('body-mobile-menu');
  }));

  // Display Submenu
  $(selectors.submenuLink).on('click', (function(evt){
    evt.preventDefault();
    var activeSubmenuId = $(this).attr('id');
    var activeSlug = activeSubmenuId.split(navSubmenuSlugClassPrefix).pop();
    var activeSubmenu = "#" + navSubmenuListClassPrefix + activeSlug ;    
    $(activeSubmenu).parent().addClass(navSubmenuAnimationClass);
  }));

  // Hide Submenu
  $(selectors.submenuCloseLink).on('click', (function(){
    $(this).parent().removeClass(navSubmenuAnimationClass);
  }));

}());

/**
 * Cart Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart
 * template.
 *
 * @namespace cart
 */

 theme.cart = (function() {
  
  var selectors = {
    form: '[data-cart-form]',
    formQty: 'select[name^="updates"]'
  }

  if( !$('body').is('.template-cart')){
    return;
  }

  var $form = $( selectors.form );

  $form.on('change', selectors.formQty, function(){
    var qty = $(this).val();
    var aux = $(this).attr('id').split('_');
    aux = aux[1].split(':');
    variation_id = parseInt(aux[0]);
    
    var updateCart = {};
    updateCart[variation_id] = qty;
    jQuery.post('/cart/update.js', {updates:updateCart } ,function(){}, "json").done(function( data ) {
      var promise = $.fn.resolveGC(data);
      if(promise){
        promise.always(function() {
          $( selectors.form ).submit();
        });
      }else{
        $( selectors.form ).submit();
      }
      
    }).always(function() {
      //$( selectors.form ).submit();
    });
  });

  
  var text_max = parseInt($('#CartSpecialInstructions').attr('maxlength'));
  $('#textarea_counter').html(text_max + ' characters remaining');

  $('#CartSpecialInstructions').keyup(function() {
      var text_length = $('#CartSpecialInstructions').val().length;
      var text_remaining = text_max - text_length;

      $('#textarea_counter').html(text_remaining + ' characters remaining');
  });
  
  

})();

slate.desktopNav = (function(){

  var $window = $(window);

  var selectors = {
    header: '[data-desktop-nav-container]',
    pencilBanner: '#shopify-section-pencil-banner',
    contentWindow: '#MainContent'
  }

  var navAnimationClass = 'Header--fixed';
  var $header = $(selectors.header);
  var $pencilBanner = $(selectors.pencilBanner);
  var $contentWindow = $(selectors.contentWindow);

  function pencilStickyCheck() {
    var $headerHeight = $header.outerHeight();
    var $offset = $pencilBanner.outerHeight();

    if( $window.scrollTop() >  ( $offset ) ) {
      $header.addClass(navAnimationClass);
      $contentWindow.css('margin-top', $headerHeight);
    } else {
      $header.removeClass(navAnimationClass);
      $contentWindow.css('margin-top', 0);
    }
  }

  $window.on('scroll', $.throttle(50, requestAnimationFrame.bind(window, pencilStickyCheck)) ); 
  $window.ready( pencilStickyCheck ); 

})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('collection', theme.Collection);
  sections.register('pencil-banner', theme.PencilBanner);
  sections.register('slider', theme.Slider);
  sections.register('footer', theme.Footer);
  sections.register('header', theme.Header);
  sections.register('faq', theme.Faq);
  sections.register('imageHover', theme.imageHover);

  //manage search
  $(".icon-search").click(function() {
    if($("#SearchDesktop").val().length>0){
      $("#mainSearchForm").submit();
    }
  });

  if (!$('body').hasClass('template-cart')) {
    slate.AjaxCart.init();
  }

  // Maybe find / invent a better place to put this?  We don't have any way of hooking into CLP templates (because they don't technically exist)
  if ($('.Clp-block').length) {
    slate.ProductThumbnails.init();
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Back to top button
  slate.BackToTop.init();

  var filter_scene, mobile_scene;
  var $filter_el = $('.js-filter-main-container');

  var responsive =  {
    _ww: function () {
      var newW = $(window).width();
      return newW;
    },
    _bp: {
      small: 576
    },
    _bp_check: function () {
      if (this._ww() > this._bp.small) {
        return 'SMALL-UP'
      } else {
        return 'SMALL'
      }
    }
  };

  var filters_setup = {
    windowBindings: function () {
      var self = this;

      $(window).on('resize', function(){
        if (responsive._bp_check() === 'SMALL-UP') {
          if ($filter_el.length > 0) {
            if (filter_scene) {
              filter_scene.destroy(true);
            }
            self.filters();
          }
        } else if (responsive._bp_check() === 'SMALL') {
          if ($filter_el.length > 0) {
            if (filter_scene) {
              filter_scene.destroy(true);
            }
          }
        }
      })
    }
  }

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
